import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    isLoading: false,
    userList: [],
    currentUser: {},
    roleList: [],
    supervisorOptions: [],
    supervisorListOptions: [],
    dropdownRole: [],
    currentPermission: {},
    roleOptions: [],
    roles: [],
    actionCodes: [],
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setUserList(state, action) {
      state.userList = action.payload;
    },
    setCurrentUser(state, action) {
      state.userDropDown = action.payload;
    },
    setRoleList(state, action) {
      state.roleList = action.payload;
    },
    setSupervisorOptions(state, action) {
      state.supervisorOptions = action.payload
    },
    setSupervisorListOptions(state, action) {
      state.supervisorListOptions = action.payload
    },
    setDropdownRole(state, action) {
      state.dropdownRole = action.payload;
    },
    setCurrentPermission(state, action) {
      state.currentPermission = action.payload;
    },
    setRoleOptions(state, action) {
      state.roleOptions = action.payload;
    },
    setRoles(state, action) {
      state.roles = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setUserList,
  setCurrentUser,
  setRoleList,
  setSupervisorOptions,
  setSupervisorListOptions,
  setDropdownRole,
  setCurrentPermission,
  setRoleOptions,
  setRoles
} = userSlice.actions;
export default userSlice.reducer;
